module.exports = "<div *ngIf=\"loading\"\r\n     class=\"imageProgress\">\r\n    <app-image-progress></app-image-progress>\r\n</div>\r\n<div #printEleStyle class=\"print_style\"></div>\r\n    <div #wrapper class=\"image_wrapper\">\r\n    </div>\r\n    <!-- <div style=\"display: none;\">\r\n        <div #domDownloadImage style=\"display: block; position: relative;\"></div>\r\n    </div> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/base-image/base-image.component.html
// module id = ./src/app/commons/base-image/base-image.component.html
// module chunks = main